import React, { useState, useEffect } from 'react';

function ReferenceView() {
  const [championList, setChampionList] = useState([]);
  const [selectedChampions, setSelectedChampions] = useState(Array(10).fill(null)); // Adjusted array size for 10 slots
  const [referenceAbilities, setReferenceAbilities] = useState(Array(10).fill(null));

  useEffect(() => {
    const fetchChampionList = async () => {
      const response = await fetch(`${process.env.PUBLIC_URL}/data/champion.json`);
      const jsonData = await response.json();
      setChampionList(Object.values(jsonData.data));
    };
    fetchChampionList();
  }, []);

  const getAvailableChampions = (currentSlot) => {
    return championList.filter(
      (champion) => !selectedChampions.includes(champion.id) || selectedChampions[currentSlot] === champion.id
    );
  };

  const handleChampionSelect = async (championId, slot) => {
    const newSelectedChampions = [...selectedChampions];
    newSelectedChampions[slot] = championId;
    setSelectedChampions(newSelectedChampions);
  
    try {
      // Fetch Data Dragon API data
      const ddragonResponse = await fetch(
        `https://ddragon.leagueoflegends.com/cdn/14.21.1/data/en_US/champion/${championId}.json`
      );
      const ddragonData = await ddragonResponse.json();
      const championData = ddragonData.data[championId];
  
      // Fetch fallback data from processedChampionData.json
      const processedResponse = await fetch('/data/processedChampionData.json');
      const processedData = await processedResponse.json();
      const fallbackChampion = processedData[championId];
  
      // Map abilities and prioritize rechargeTime if available
      const abilities = championData.spells.map((spell, index) => {
        const fallbackSpell = fallbackChampion?.abilities[`spell${index + 1}`];
  
        // Log the fallback spell data for debugging
        console.log(`Processing spell ${index + 1} for ${championId}`);
        console.log("Fallback spell data:", fallbackSpell);
  
        // Retrieve cooldown and rechargeTime
        const cooldown = spell.cooldown ?? fallbackSpell?.cooldown;
  
        // Ensure rechargeTime is an array or fallback to ammoRechargeTime
        let rechargeTime = Array.isArray(fallbackSpell?.rechargeTime) ? fallbackSpell.rechargeTime : null;

        // If rechargeTime is not a valid array, use the Data Dragon ammoRechargeTime
        if (!Array.isArray(rechargeTime) || rechargeTime.length === 0 || rechargeTime.includes("N/A")) {
          rechargeTime = spell.ammo?.ammoRechargeTime;
        }

        // Log the values for debugging
        console.log("Cooldown:", spell.cooldown);
        console.log("Recharge Time:", rechargeTime);
  
        // Check if rechargeTime has valid non-zero values
        const hasValidRechargeTime =
          Array.isArray(rechargeTime) && rechargeTime.some((val) => val > 0);
  
        // Use rechargeTime if it is valid, otherwise use cooldown
        const cooldowns = hasValidRechargeTime
          ? rechargeTime.join('/')
          : (Array.isArray(cooldown) ? cooldown.join('/') : 'Unknown');
  
        // Log the final cooldowns used
        console.log("Final Cooldowns:", cooldowns);
  
        return {
          name: spell.name,
          iconPath: `https://ddragon.leagueoflegends.com/cdn/14.21.1/img/spell/${spell.image.full}`,
          cooldowns,
          key: ['Q', 'W', 'E', 'R'][index],
        };
      });
  
      const newReferenceAbilities = [...referenceAbilities];
      newReferenceAbilities[slot] = { championId, abilities };
      setReferenceAbilities(newReferenceAbilities);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  return (
      <div>
        <h1>Reference Mode - Select Champions</h1>
        <div className="full-lobby">
          {/* First Team/Section */}
          <div className="champion-selection">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="champion-slot">
                <select
                  onChange={(e) => handleChampionSelect(e.target.value, index)}
                  value={selectedChampions[index] || ""}
                >
                  <option value="">Champ {index + 1}</option>
                  {getAvailableChampions(index).map((champion) => (
                    <option key={champion.id} value={champion.id}>{champion.name}</option>
                  ))}
                </select>
    
                {referenceAbilities[index] && (
                  <div className="champion-info">
                    <img
                      src={`https://ddragon.leagueoflegends.com/cdn/14.21.1/img/champion/${championList.find(champ => champ.id === referenceAbilities[index].championId)?.image.full}`}
                      alt={`${referenceAbilities[index].championId} Icon`}
                      className="champion-image"
                    />
                    <div className="abilities">
                      {referenceAbilities[index].abilities.map((ability) => (
                        <p key={ability.key}>
                          {ability.key}: {ability.cooldowns}
                        </p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
    
          {/* Second Team/Section */}
          <div className="champion-selection">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index + 5} className="champion-slot">
                <select
                  onChange={(e) => handleChampionSelect(e.target.value, index + 5)}
                  value={selectedChampions[index + 5] || ""}
                >
                  <option value="">Champ {index + 6}</option>
                  {getAvailableChampions(index + 5).map((champion) => (
                    <option key={champion.id} value={champion.id}>{champion.name}</option>
                  ))}
                </select>
    
                {referenceAbilities[index + 5] && (
                  <div className="champion-info">
                    <img
                      src={`https://ddragon.leagueoflegends.com/cdn/14.21.1/img/champion/${championList.find(champ => champ.id === referenceAbilities[index + 5].championId)?.image.full}`}
                      alt={`${referenceAbilities[index + 5].championId} Icon`}
                      className="champion-image"
                    />
                    <div className="abilities">
                      {referenceAbilities[index + 5].abilities.map((ability) => (
                        <p key={ability.key}>
                          {ability.key}: {ability.cooldowns}
                        </p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      
      {/* CSS Styles */}
      <style jsx>{`
        .full-lobby {
          display: flex;
          gap: 200px;
          justify-content: space-around;
        }

        .champion-selection {
          display: flex;
          justify-content: start;
          align-items: center;
          height: 100%;
          flex-direction: column;
          gap: 1em;
        }

        .champion-slot {
          text-align: center;
          width: 300px;
        }

        .champion-info {
          display: flex;
          flex-direction: row;
          margin-top: 10px;
          justify-content: center;
          height: 100px;
        }

        .champion-image {
          width: 100px;
          height: 100px;
        }

        .abilities {
          text-align: left;
          font-size: 0.7em;
          display: flex;
          flex-direction: column;
          gap: 5px;
          padding: 8px;
          background: rgba(0, 0, 0, 0.5);
          color: white;
        }

        p {
          margin: 0px;
        }

        /* For small screens (iPhone SE, 375px width) */
        @media (max-width: 450px) {
          .full-lobby {
            flex-direction: column;
            gap: 20px; /* Reduce gap for smaller screens */
            justify-content: center;
            align-items: center;
          }

          .champion-selection {
            width: 100%; /* Use full width */
            max-width: 320px; /* Limit width for mobile view */
          }

          .champion-slot {
            width: 100%;
            text-align: center;
            margin-bottom: 10px;
          }

          .champion-info {
            flex-direction: column;
            align-items: center;
            height: auto;
            margin-top: 10px;
          }

          .champion-image {
            width: 80px;
            height: 80px;
          }

          .abilities {
            font-size: 12px;
            padding: 5px;
          }

          p {
            font-size: 12px;
          }

          select {
            width: 90%;
            font-size: 14px;
            padding: 5px;
          }
        }

        /* Further adjustments for ultra-small screens (e.g., 320px width) */
        @media (max-width: 320px) {
          .champion-image {
            width: 60px;
            height: 60px;
          }

          .abilities {
            font-size: 10px;
          }

          select {
            font-size: 12px;
            padding: 4px;
          }
        }
      `}</style>
    </div>
  );
}

export default ReferenceView;
